import 'selectric';

let select = $ => {
  $('.select__element').selectric({
    nativeOnMobile: false
  });
};

export default select;



// WEBPACK FOOTER //
// ./app/blocks/select/select.js